import { RegExpUtility } from "../RegExpUtility";

export type Variables = {[index:string]:string }
export class VariableReplacer
{
  static replace( source:string, variables:Variables )
  {
    for ( let it in variables )
    {
      let regexSource = RegExpUtility.toRegexSource( "${" + it + "}" ); 
      source = source.replace( new RegExp( regexSource, "g" ), variables[ it ] );      
    }

    return source;
  }
}